/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-curly-newline */
import React from 'react';
import { FormHandles } from '@unform/core';

import Button from '../../../../../components/Button';
import Loading from '../../../../../components/Loading';

import Modal from '../../../../../components/Modal';

import { Container, Content, ActionSaveModal } from './styles';

interface ModalDTO {
  formRef: any | FormHandles;
  loadModalProp: boolean;
  closeModalFinishedQuote: () => void;
}

const ModalConfirmationFinishedQuote: React.FC<ModalDTO> = ({
  formRef,
  loadModalProp = false,
  closeModalFinishedQuote,
}) => {
  return (
    <Modal visibleProp={loadModalProp}>
      <Container>
        <h1>Deseja marcar esta cotação como finalizada?</h1>
        <Content>
          <ActionSaveModal>
            <Button
              type="button"
              onClick={() => {
                formRef.current.setFieldValue('finishedQuote', true);
                closeModalFinishedQuote();
              }}
            >
              Sim
            </Button>
            <Button
              type="button"
              onClick={() => {
                formRef.current.setFieldValue('finishedQuote', false);
                closeModalFinishedQuote();
              }}
            >
              Não
            </Button>
          </ActionSaveModal>
        </Content>
      </Container>
    </Modal>
  );
};

export default ModalConfirmationFinishedQuote;
